import { render, staticRenderFns } from "./BulkEnrollmentUploadRules.vue?vue&type=template&id=6ae30062&scoped=true"
import script from "./BulkEnrollmentUploadRules.vue?vue&type=script&lang=ts"
export * from "./BulkEnrollmentUploadRules.vue?vue&type=script&lang=ts"
import style0 from "./BulkEnrollmentUploadRules.vue?vue&type=style&index=0&id=6ae30062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae30062",
  null
  
)

export default component.exports